"use client";

import React, { createContext, useContext, useMemo, useState } from "react";

interface IJobFavoriteContextType {
  isFavourite: boolean | undefined;
  setIsFavourite: (value: boolean | undefined) => void;
}

const JobFavoriteContext = createContext<IJobFavoriteContextType | undefined>(
  undefined
);

export function JobFavoriteProvider({
  children,
  initialFavorite,
}: {
  children: React.ReactNode;
  initialFavorite: boolean | undefined;
}): JSX.Element {
  const [isFavourite, setIsFavourite] = useState<boolean | undefined>(
    initialFavorite
  );

  const value = useMemo(() => ({ isFavourite, setIsFavourite }), [isFavourite]);

  return (
    <JobFavoriteContext.Provider value={value}>
      {children}
    </JobFavoriteContext.Provider>
  );
}

export function useJobFavorite(): IJobFavoriteContextType {
  const context = useContext(JobFavoriteContext);
  if (context === undefined) {
    throw new Error("useJobFavorite must be used within a JobFavoriteProvider");
  }
  return context;
}
